<form *ngIf="tagsForm" [formGroup]="tagsForm" class="definition-form" id="ce-prj3-form">
  <mat-label class="display-title" id="ce-prj3-obj-label">Select objectives</mat-label>
  <!-- removing the icon till we do not have a popup -->
  <!-- <mat-icon>add_circle</mat-icon> <br /> -->
  <div formArrayName="objectives" id="ce-prj3-obj-array">
    <div *ngIf="objectives.length === 0" class="no-data">No objectives found</div>
    <mat-checkbox
      *ngFor="let ob of objectives; let i = index"
      [formControlName]="i"
      (change)="onObjectiveChange(i)"
      [matTooltip]="ob.objectiveTitle.length > 30 ? ob.objectiveTitle : ''"
      matTooltipPosition="above"
      [id]="'ce-prj3-obj-' + i"
    >
      {{ ob.objectiveTitle.length > 30 ? (ob.objectiveTitle | slice: 0 : 30) + '...' : ob.objectiveTitle }}<br />
      <mat-label
        class="lbl-sub"
        [matTooltip]="ob.objectiveDescription.length > 40 ? ob.objectiveDescription : ''"
        matTooltipPosition="above"
        [id]="'ce-prj3-obj-desc-' + i"
      >
        {{
          ob.objectiveDescription.length > 40
            ? (ob.objectiveDescription | slice: 0 : 40) + '...'
            : ob.objectiveDescription
        }}
      </mat-label>
    </mat-checkbox>
  </div>
  <hr class="separator" />
  <mat-label class="display-title" id="ce-prj3-tag-label">Select Tags</mat-label>
  <!-- removing the icon till we do not have a popup -->
  <!-- <mat-icon>add_circle</mat-icon>  -->
  <br />
  <div formArrayName="tags" class="tags-grid" id="ce-prj3-tag-array">
    <div *ngIf="tags.length === 0" class="no-data">No tags found</div>
    <mat-checkbox
      *ngFor="let tg of tags; let i = index"
      class="tag-chip"
      [formControlName]="i"
      (change)="onTagChange(i)"
      [id]="'ce-prj3-tag-' + i"
    >
      <span class="tag-text">
        <app-icon-display [icon]="tg.icon" [id]="'ce-prj3-tag-icn-' + i"></app-icon-display>
        <div
          class="label-content"
          [matTooltip]="tg.tagTitle.length > 30 ? tg.tagTitle : ''"
          matTooltipPosition="above"
          [id]="'ce-prj3-tag-lbl-' + i"
        >
          {{ tg.tagTitle.length > 30 ? (tg.tagTitle | slice: 0 : 30) + '...' : tg.tagTitle }}<br />
          <mat-label
            class="lbl-sub"
            [matTooltip]="tg.tagDescription.length > 40 ? tg.tagDescription : ''"
            matTooltipPosition="above"
            [id]="'ce-prj3-tag-desc-' + i"
          >
            {{ tg.tagDescription.length > 40 ? (tg.tagDescription | slice: 0 : 40) + '...' : tg.tagDescription }}
          </mat-label>
        </div>
      </span>
    </mat-checkbox>
  </div>
  <br />
</form>
